import React, { useContext, useState, useEffect } from 'react';
import forgetIcon from '../../../Assets/Images/catchforgetIcon.png'
import { FormForgetPassConfirmCode, LangContext } from '../../../App'
import { Modal, Row, Col } from 'react-bootstrap'
import { useForm } from "react-hook-form";
import './ForgetPassword.css'
import { API_ENDPOINT } from '../../../AppConfig';
import axios from 'axios';
import ConfirmCode from './ConfirmCode'
import string from '../../../Assets/Localization/Local'

const Phonenumber = (props) => {
  const { lang } = useContext(LangContext)
  const [show, setShow] = useState(true);
  const [data, setData] = useState();

  const { openFormConfirmCode, ToggleForm_forgetPass_ConfirmCode } = useContext(FormForgetPassConfirmCode)

  const { register, handleSubmit,errors } = useForm({
    // validationSchema: props.validation
  });


  useEffect(() => {
    // console.log('openFormConfirmCode==> ', openFormConfirmCode)
    if (openFormConfirmCode === true) {
      setShow(false)
    }
  })

  const onSubmit = (data) => {
    // console.log('data==>>> ', data)
    setData(data)
    let uri = `${API_ENDPOINT}/phoneForgetPassword`
    let SubmitData = {}
    SubmitData.phone = data.phone
    axios.post(uri, SubmitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      console.log('forgetPass done=> ', response.data)
      ToggleForm_forgetPass_ConfirmCode()
      // console.log('openFormConfirmCode=> ', openFormConfirmCode)

    }).catch(error => {
      ToggleForm_forgetPass_ConfirmCode()
      // console.log('forgetPass error=> ', error.response)
    })
  }
  string.setLanguage(lang)

  return (
    <div>
      <Modal className="forgetmodal" show={show} onHide={props.close} animation={false}>
        <Modal.Header className="justify-content-center pb-0">
          <h3 className="mt-3">{string.forget}</h3>
          <i style={{ left: "10px" }} onClick={props.close} className="fas fa-times close-icon"></i>
        </Modal.Header>
        <Modal.Body>
          <div className="imgforgetcontainer">
            <img src={forgetIcon} alt="deleteimg" />
          </div>
          <h5>{string.sendcode}</h5>
          <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }}>
            <Row>
              <Col lg='12' style={{ marginBottom: '40px' }}>
                <div className="textWithIcon"  >
                  <label className="forget-label" style={{textAlign: lang==="ar"?"right":"left"}}>{string.mobilenum}</label>
                  <input type="text" name="phone" 
                   ref={register({ required: true })}
                  placeholder="" className="forget-input pb-2" style={{textAlign: lang==="ar"?"right":"left"}} />
                  {errors['phone'] && <p className="Errorstyle">يجب ادخال رقم الجوال *</p>}
                </div>

              </Col>
            </Row>
            <button className="btn nextBTN btn-block mb-4" type="submit">{string.nextBTN}</button>
          </form>
        </Modal.Body>
      </Modal>
      {openFormConfirmCode && <ConfirmCode close={ToggleForm_forgetPass_ConfirmCode} phone={data} />}
    </div >
  );
}

export default Phonenumber;

